import React from 'react'

export const CopyrightIcon = ({ ...iconProps }) => (
  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" { ...iconProps }>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.9166 0.867188L0.703125 6.48869V9.1293H1.95818V17.0504H21.7906V9.1293H23.2977V6.48869L11.9166 0.867188ZM19.3641 14.6648H4.385V7.42563L11.9166 3.5078L19.3643 7.42563L19.3641 14.6648Z" fill="white"/>
  </svg>
);
